export class TimeUtils {
  public static secondsToHMS(seconds: number): string {
    if (seconds < 60) {
      return `${seconds} second`
    } else if (seconds >= 60 && seconds < 3600) {
      return this.formatTime(seconds, 60, 'minute', 1, 'second')
    } else if (seconds >= 3600) {
      return this.formatTime(seconds, 3600, 'hour', 60, 'minute')
    }
    return ''
  }

  public static formatTime(
    seconds: number,
    unit: number,
    unitName: string,
    remainingUnit: number,
    remainingUnitName: string,
  ): string {
    let units = Math.floor(seconds / unit)
    let remainingUnits = Math.floor((seconds % unit) / remainingUnit)
    if (!remainingUnits) {
      return `${units} ${unitName}`
    } else {
      return `${units} ${unitName}, ${remainingUnits} ${remainingUnitName}`
    }
  }

  /**
   * Adds passed number of seconds to a time
   * @param value
   * @param secondsToAdd
   */
  public static addTime(value: string | Date, secondsToAdd: number): string {
    return new Date(new Date(value).getTime() + secondsToAdd).toISOString()
  }
}
